export const idProjectEnergiaSolar = '6c035acf-e9bb-4678-a761-84b7d1007989';

export const projectsNotShowSimulator = [

  '6c035acf-e9bb-4678-a761-84b7d1007989',
];
